import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_BASE_URL || "https://bbjlatavola.com/wp-json";

const client = axios.create({
  baseURL,
  timeout: 15000,
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Request failed";
    return Promise.reject(Object.assign(new Error(message), { cause: error }));
  }
);

export default client;
